import { Anchor, Contrast, Magnet, SquareDashed } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useShallow } from "zustand/react/shallow";
import { useScheduleStore } from "../../stores/schedule-store";
import { useMetadataEditingStore } from "../../stores/metadata-editing-store";
import { ToolbarToggle } from "./ToolbarToggle";
import { useCanvasDayAnchorsEnabled } from "../../lib/schedule-art/canvas-state";

export function MetadataViewToggles() {
  const { t } = useTranslation();
  const view = useMetadataEditingStore(useShallow(state => ({
    snapping: state.snapping,
    dayBounds: state.dayBounds,
    grayscale: state.grayscale,
    setView: state.setView,
  })));
  const anchorsVisible = useScheduleStore(state => state.anchorsVisible);
  const dayAnchorsEnabled = useCanvasDayAnchorsEnabled();
  const toggleAnchors = useScheduleStore(state => state.toggleAnchors);

  return (
    <>
      <ToolbarToggle label={t("metadata.canvas.snap")} pressed={view.snapping} onToggle={snapping => view.setView({ snapping })}>
        <Magnet />
      </ToolbarToggle>
      <ToolbarToggle label={t("metadata.canvas.dayBounds")} pressed={view.dayBounds} onToggle={dayBounds => view.setView({ dayBounds })}>
        <SquareDashed />
      </ToolbarToggle>
      {dayAnchorsEnabled && <ToolbarToggle label={t("art.showAnchors")} pressed={anchorsVisible} onToggle={() => toggleAnchors()}>
        <Anchor />
      </ToolbarToggle>}
      <ToolbarToggle label={t("metadata.canvas.grayscale")} pressed={view.grayscale} onToggle={grayscale => view.setView({ grayscale })}>
        <Contrast />
      </ToolbarToggle>
      <span className="mx-1 h-5 w-px bg-neutral-200" />
    </>
  );
}
